import TabSectionButton from './TabSectionButton';

export default TabSectionButton;
